import { render, staticRenderFns } from "./CodeBooks.vue?vue&type=template&id=0007fd5a&scoped=true&"
import script from "./CodeBooks.vue?vue&type=script&lang=js&"
export * from "./CodeBooks.vue?vue&type=script&lang=js&"
import style0 from "./CodeBooks.vue?vue&type=style&index=0&id=0007fd5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0007fd5a",
  null
  
)

export default component.exports